import { render, staticRenderFns } from "./regUnOrderExport.vue?vue&type=template&id=2b4c77ea&scoped=true&"
import script from "./regUnOrderExport.vue?vue&type=script&lang=js&"
export * from "./regUnOrderExport.vue?vue&type=script&lang=js&"
import style0 from "./regUnOrderExport.vue?vue&type=style&index=0&id=2b4c77ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4c77ea",
  null
  
)

export default component.exports